import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/home/stake-img01.png'
import _imports_1 from '../../assets/images/home/stake-img02.png'
import _imports_2 from '../../assets/images/home/about-img.png'


const _withScopeId = n => (_pushScopeId("data-v-060186b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner-section" }
const _hoisted_3 = { class: "neco-coin-section" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "value" }, "1,000,000", -1))
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "" }, "0xd23891FC1A515A88C571064637502e3766819e2d", -1))
const _hoisted_14 = { class: "platform-section" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "icon-wrapper" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "info" }
const _hoisted_19 = { class: "name" }
const _hoisted_20 = {
  key: 0,
  class: "desc"
}
const _hoisted_21 = { class: "stake-section" }
const _hoisted_22 = { class: "stake-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_24 = { class: "content-wrapper" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "desc-row" }
const _hoisted_27 = { class: "left" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "name" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "APY", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "stake-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_36 = { class: "content-wrapper" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "desc-row" }
const _hoisted_39 = { class: "left" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "name" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "APY", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "about-section" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "image",
    src: _imports_2
  })
], -1))
const _hoisted_48 = { class: "content-wrapper" }
const _hoisted_49 = { class: "title" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-paw" }, null, -1))
const _hoisted_51 = { class: "desc" }
const _hoisted_52 = { class: "sub-desc" }
const _hoisted_53 = { class: "copyright-section" }
const _hoisted_54 = { class: "btn-wrapper" }
const _hoisted_55 = { class: "btn-content" }
const _hoisted_56 = { class: "btn-content" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" @ copyright NECO FUN ")

import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { PlatformItem, platformList, bannerList } from '@/configs/home';
import { useStore } from '@/store';
import { getTotalSupply } from '@/common/contracts/apis/neco-token-api';
import Tools from '@/common/tools';
import {
  calculateApy,
  getHalvingDuration,
  getTotalStaked,
} from '@/common/contracts/apis/neco-farming-api';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const clickPlatform = (platform: PlatformItem) => {
  window.open(platform.link);
};

const buyNECO = () => {
  window.open('https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0xd23891FC1A515A88C571064637502e3766819e2d');
};

const store = useStore();
const router = useRouter();

const necoCurrentSupply = ref('0');
const getCurrentSupply = async () => {
  if (store.state.web3 !== null) {
    getTotalSupply(store.state.web3, store.state.currentChainId).then((result) => {
      necoCurrentSupply.value = Tools.truncateDecimals(result);
    });
  }
};

const pool1TotalStaked = ref('0');
const getPool1TotalStaked = async () => {
  if (store.state.web3 !== null) {
    getTotalStaked(store.state.web3,
      '0x8B5a4a4F3abdd03cb241A5C09F032051656b68E1').then((result) => {
      pool1TotalStaked.value = Tools.truncateDecimals(result);
    });
  }
};

const pool1APY = ref('0');
const getPool1APY = async () => {
  if (store.state.web3 !== null) {
    calculateApy(
      store.state.web3,
      '0x8B5a4a4F3abdd03cb241A5C09F032051656b68E1',
      false,
      '0xd23891FC1A515A88C571064637502e3766819e2d',
    ).then((result) => {
      pool1APY.value = result;
    });
  }
};

const pool2TotalStaked = ref('0');
const getPool2TotalStaked = async () => {
  if (store.state.web3 !== null) {
    getTotalStaked(store.state.web3,
      '0xD2CB19C09417DA49658e3Fd0196aDfa350780277').then((result) => {
      pool2TotalStaked.value = Tools.truncateDecimals(result);
    });
  }
};

const pool2APY = ref('0');
const getPool2APY = async () => {
  if (store.state.web3 !== null) {
    calculateApy(
      store.state.web3,
      '0xD2CB19C09417DA49658e3Fd0196aDfa350780277',
      true,
      '0xd91b0CA001B014C898E0564F4450b0269A730fC1',
    ).then((result) => {
      pool2APY.value = result;
    });
  }
};

onMounted(() => {
  getCurrentSupply();
  getPool1TotalStaked();
  getPool1APY();
  getPool2TotalStaked();
  getPool2APY();
});

watch([
  () => store.state.web3,
  () => store.state.currentAccount,
  () => store.state.currentChainId], () => {
  getCurrentSupply();
  getPool1TotalStaked();
  getPool1APY();
  getPool2TotalStaked();
  getPool2APY();
});

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_carousel, {
        "indicator-position": "outside",
        height: "30vw"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bannerList), (item) => {
            return (_openBlock(), _createBlock(_component_el_carousel_item, {
              key: item,
              class: _normalizeClass(["banner-item", item])
            }, null, 8, ["class"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('necoCoinTitle')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('maxSupply')), 1),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('turnover')), 1),
        _createElementVNode("span", _hoisted_10, _toDisplayString(necoCurrentSupply.value), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('contractAddress')) + "：", 1),
        _hoisted_13
      ]),
      _createVNode(_component_el_button, {
        onClick: buyNECO,
        class: "buy-btn black-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('buy')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformList), (platform, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (clickPlatform(platform)),
          key: index,
          class: "platform"
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              class: "icon",
              src: platform.icon,
              alt: ""
            }, null, 8, _hoisted_17)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(platform.name), 1),
            (platform.desc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(platform.desc), 1))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_15))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('pool1Title')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('stakeAmount')), 1),
                _createElementVNode("span", _hoisted_30, _toDisplayString(pool1TotalStaked.value) + " NECO", 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("span", _hoisted_33, _toDisplayString(pool1APY.value) + "%", 1)
              ])
            ]),
            _createVNode(_component_el_button, {
              class: "go-btn black-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'token-farming' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('go')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('pool2Title')), 1),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('stakeAmount')), 1),
                _createElementVNode("span", _hoisted_42, _toDisplayString(pool2TotalStaked.value) + " BNB&NECO", 1)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("span", _hoisted_45, _toDisplayString(pool2APY.value) + "%", 1)
              ])
            ]),
            _createVNode(_component_el_button, {
              class: "go-btn black-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'token-farming' })))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('go')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('about')), 1)
        ]),
        _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('desc')), 1),
        _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('detail')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_53, [
      _createElementVNode("div", _hoisted_54, [
        _createVNode(_component_el_button, {
          class: "white-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/airdrop')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('airdrop')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "white-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/exchange')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('exchange')), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_57
    ])
  ]))
}
}

})